export default [
    {
        path: 'parametrizacao',
        component: () => import(
            '@/views/transporte-paciente/parametrizacao/Index'
        ),
        redirect: 'parametrizacao/create',
        children: [
            {
                name: 'transporte-paciente-parametrizacao-create',
                path: 'create',
                component: () => import(
                    '@/views/transporte-paciente/parametrizacao/Form'
                ),
            },
            {
                name: 'transporte-paciente-parametrizacao-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    '@/views/transporte-paciente/parametrizacao/Form'
                ),
            },
        ],
    },
]